import React from 'react';
import { Marker } from '@react-google-maps/api';

import { Coordinates } from '@ocx-app/modules/stores/types';

import CurrentLocationIcon from './assests/current-location.svg';

type CurrentLocationProps = {
  currentLocation: Coordinates;
};

export const CurrentLocation: React.FC<CurrentLocationProps> = (props) => {
  const { currentLocation } = props;
  return (
    <Marker
      options={{
        icon: CurrentLocationIcon,
      }}
      position={currentLocation}
    />
  );
};
